import { toTreatmentOptionPayloadType } from "domain/menuOptions";
import {
  aboutLoanEncoder,
  attestationEncoder,
  SelectedTreatmentPayloadType,
} from "domain/selectedTreatments";
import { action, computed, observable } from "mobx";
import { Nullable } from "util/extendedTypes";
import { AboutYourLoanStore } from "./aboutYourLoanStore";
import { AboutYouStore } from "./aboutYouStore";
import { AssertionStore } from "./assertionsStore";
import { AttestationStore } from "./attestationStore";
import { IndicativeRepaymentOptionsStore } from "./indicativeRepaymentOptionsStore";
import { MenuStore } from "./menuStore";
import { SelectedTreatmentStore } from "./selectedTreatmentsStore";
import { Error } from "../domain/error";
import { SelectedTreatmentPostStore } from "./selectedTreatmentPostStore";

export class Store {
  public aboutYouStore = new AboutYouStore();
  public assertionsStore = new AssertionStore();
  public aboutYourLoanStore = new AboutYourLoanStore();
  public attestationStore = new AttestationStore();
  public indicativeRepaymentOptionsStore =
    new IndicativeRepaymentOptionsStore();
  public selectedTreatmentStore = new SelectedTreatmentStore();
  public selectedTreatmentPostStore = new SelectedTreatmentPostStore();
  public menuStore = new MenuStore();

  @observable
  init: boolean = false;

  @action
  bootstrap(): void {
    this.init = true;
  }

  @computed
  get error(): Nullable<Error> {
    return (
      this.indicativeRepaymentOptionsStore.error ||
      this.selectedTreatmentPostStore.error
    );
  }

  @computed
  get hasInvalidNumberOfRepayments(): boolean {
    return this.indicativeRepaymentOptionsStore.hasInvalidNumberOfRepayments;
  }

  @computed
  get fetching(): boolean {
    return (
      this.indicativeRepaymentOptionsStore.fetching ||
      this.selectedTreatmentPostStore.fetching
    );
  }
  @computed
  get selectedTreatmentPayload(): SelectedTreatmentPayloadType {
    const { confirmEmail, ...aboutYou } = this.aboutYouStore.data;
    const aboutLoan = this.aboutYourLoanStore.data;
    return {
      aboutYou: aboutYou,
      aboutLoan: aboutLoanEncoder(aboutLoan),
      treatmentOptionType: toTreatmentOptionPayloadType(
        this.selectedTreatmentStore.selectedTreatments.treatmentOptionType
      ),
      hardStoppedOnUI: this.attestationStore.hardStoppedOnUI,
      attestationInformation: attestationEncoder(this.attestationStore.answers),
      selectedOptionType:
        this.selectedTreatmentStore.selectedTreatments.selectedOptionType!,
      existingLoanDetails:
        this.indicativeRepaymentOptionsStore.existingLoanDetails,
      repaymentOptions: this.indicativeRepaymentOptionsStore.repaymentOptions,
    };
  }
}
